// src/api/client.ts
import axios from './axiosConfig'; // Use configured axios with retry logic
import { baseUrl } from '../constants';

export const api = axios.create({
  baseURL: baseUrl,        // you already use this const
  withCredentials: false,   // keep if you use cookies
  timeout: 20000,
});

// Attach bearer token from localStorage (you used "accessToken" in your Users page)
api.interceptors.request.use((config) => {
  const token = typeof window !== 'undefined'
    ? (localStorage.getItem('accessToken') || localStorage.getItem('token'))
    : null;
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Common API functions
export const listAccounts = () =>
  api.get('/accounts/visible');

// Task API functions
export const getTaskAssignmentsByStep = (taskId: number) =>
  api
    .get(`/tasks/${taskId}/assignments-by-step`)
    .catch(() => ({ data: [] }));
